'use client'
import { useTranslations } from 'next-intl'

const FaqSection = ({ activeTab, setActiveTab, moveTo }) => {
  const t = useTranslations('faqPage.faq-part')
  const handleActiveTab = (faq) => {
    setActiveTab(faq)
    moveTo(document.getElementById(faq), faq)
  }
  const faqs = ['signUp', 'logIn', 'bookings', 'payments', 'account', 'support']
  return (
    <div className='sticky top-[155px]'>
      <h3 className='leading-[1.4] md:text-[28px] text-[30px] font-light mb-12'>
        {t('title')}
      </h3>
      <div className='flex-col hidden md:flex gap-2'>
        {faqs.map((faq) => (
          <p
            key={faq}
            onClick={() => handleActiveTab(faq)}
            className={`font-light cursor-pointer ${
              activeTab === faq ? 'font-normal' : ''
            }`}
          >
            {t(`faqs.${faq}`)}
          </p>
        ))}
      </div>
    </div>
  )
}

export default FaqSection
